import { useMutation } from '@tanstack/react-query'
import type { ReturnsApiCreateLiteOrderRequest } from '@itsrever/rever-api'
import { returnsApi } from '@/services/api/returns-api'

const createLiteOrder = async (req: ReturnsApiCreateLiteOrderRequest) => {
  const { data } = await returnsApi.createLiteOrder(req)

  return data
}

export const useCreateLiteOrder = () => {
  return useMutation({
    mutationFn: createLiteOrder
  })
}
